import { render, staticRenderFns } from "./CredentialProcessHistorySave.vue?vue&type=template&id=32867e86&scoped=true"
import script from "./CredentialProcessHistorySave.vue?vue&type=script&lang=js"
export * from "./CredentialProcessHistorySave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32867e86",
  null
  
)

export default component.exports